/**
 * Référence pour les caractères Unicode : https://www.compart.com/en/unicode/html
 */
export const U_THIN_SPACE = '\u2009'; /** &thinsp; | &ThinSpace; */
export const U_NO_BREAK_SPACE = '\u00A0'; /** &nbsp; | &NonBreakingSpace; */
export const U_NARROW_NO_BREAK_SPACE = '\u202F'; /** &#x202F; */

export const U_NON_BREAKING_HYPHEN = '\u2011'; /** "‑": &#x2011; */
export const U_TIMES = '\u00D7'; /** "×": &times; */
